import React from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "../../../context/ThemeContext";

const ThemeToggle = ({ className = "" }) => {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  const tooltip = isDark ? "Switch Theme · Light Mode" : "Switch Theme · Dark Mode";
  const ariaLabel = isDark
    ? "Switch theme to light mode"
    : "Switch theme to dark mode";
  return (
    <div className={`relative group inline-flex ${className}`}>
      <button
        type="button"
        onClick={toggle}
        data-testid="theme-toggle"
        aria-label={ariaLabel}
        title={tooltip}
        className="relative w-9 h-9 inline-flex items-center justify-center rounded-full border border-gold/30 text-gold/85 hover:text-gold hover:border-gold/70 transition-colors theme-toggle"
      >
        {isDark ? <Moon size={15} strokeWidth={1.4} /> : <Sun size={15} strokeWidth={1.4} />}
      </button>
      <span
        role="tooltip"
        data-testid="theme-toggle-tooltip"
        className="pointer-events-none absolute top-full mt-2 left-1/2 -translate-x-1/2 whitespace-nowrap text-[10px] tracking-[0.25em] uppercase text-gold/85 bg-black/85 border border-gold/25 px-3 py-1.5 opacity-0 group-hover:opacity-100 group-focus-within:opacity-100 transition-opacity duration-200 z-50"
      >
        {tooltip}
      </span>
    </div>
  );
};

export default ThemeToggle;
